import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta:{
      title:'',
      requireAuth:true
    }
  },
  
  {
    path: '/home',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue'),
    redirect: '/home',
    children:[
      {//个人审核
        path: '/personalAuditing',
        name: 'personalAuditing',
        component: () => import('../views/personalAuditing'),
      },
      {//团队
        path: '/teamAuditing',
        name: 'teamAuditing',
        component: () => import('../views/teamAuditing'),
      },
      {//参数
        path: '/parameter',
        name: 'parameter',
        component: () => import('../views/parameter'),
      },
      {
        path: '/user',
        name: 'users',
        component: () => import('../views/userManage'),
      },
      {
        path: '/access',
        name: 'access',
        component: () => import('../views/accessLog'),
      },
      {
        path: '/analysis',
        name: 'analysis',
        component: () => import('../views/dataAnalysis'),
      },
    ]
  },
  // 中医博物馆预约
  {
    path: '/mobile/login',
    name: 'mobileLogin',
    component: () => import('../views/mobile/mobileLogin.vue'),
    meta:{
      title:'移动端登录',
      keepAlive:true
    }
  },
  {
    path: '/mobile/personal',
    name: 'personal',
    component: () => import('../views/mobile/personalAppointment.vue'),
    meta:{
      title:'个人预约',
      keepAlive:true
    }
  },
  {
    path: '/mobile/group',
    name: 'group',
    component: () => import('../views/mobile/groupAppointment.vue'),
    meta:{
      title:'团体预约',
      keepAlive:true
    }
  },
  {
    path: '/mobile/administration',
    name: 'administration',
    component: () => import('../views/mobile/administration.vue'),
    meta:{
      title:'审核管理',
      keepAlive:true
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
